/* src/app/features/recuperacao/protocolo/recuperacao-credito-cadastro.component.scss */
.cabecalho-recuperacao {
  margin-bottom: 30px;
}
.linha-recuperacao {
  margin-bottom: 15px;
}
/*# sourceMappingURL=recuperacao-credito-cadastro.component.css.map */
